import * as THREE from "three";

export function addCrossHair(camera) {
  const crosshair = new THREE.Mesh(
    new THREE.RingGeometry(0.01, 0.014, 12 ),
    new THREE.MeshBasicMaterial({ color: 0xffffff,opacity: 0.7,
        transparent: true, side: THREE.DoubleSide })
  );
  // place it in the center
  let crosshairPercentX = 50;
  let crosshairPercentY = 50;
  let crosshairPositionX = (crosshairPercentX / 100) * 2 - 1;
  let crosshairPositionY = (crosshairPercentY / 100) * 2 - 1;
  crosshair.position.x = crosshairPositionX * camera.aspect;
  crosshair.position.y = crosshairPositionY;
  crosshair.position.z = -1;
  camera.add(crosshair);
}
